import { CloseOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';

import * as S from './styles';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  keepMounted?: boolean;
}

export default function SidePanel({
  isOpen,
  onClose,
  title,
  children,
  footer,
  keepMounted = false,
}: Props) {
  return (
    <S.Panel
      visible={isOpen}
      onClose={onClose}
      placement="right"
      width={360}
      closable={false}
      title={null}
      aria-label={title}
      destroyOnClose={!keepMounted}
      forceRender={keepMounted}
    >
      <S.Header>
        <S.Title>{title}</S.Title>
        <S.CloseButton type="button" aria-label="Fechar" onClick={onClose}>
          <CloseOutlined aria-hidden />
        </S.CloseButton>
      </S.Header>
      <S.Content>{children}</S.Content>
      {footer && <S.Footer>{footer}</S.Footer>}
    </S.Panel>
  );
}
